import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {URLS} from '../../../environments/environment';
// import {CarsService} from '../../dashboard/orders/orders.service';
import {saveAs} from 'file-saver';
import {CarsService} from '../cars.service';
@Component({
  selector: 'app-share-car',
  templateUrl: './share-car.component.html',
  styleUrls: ['./share-car.component.scss']
})
export class ShareCarComponent implements OnInit {
  @Input() car: any;
  @Input() requireUpdate: any;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter<any>();
  shareUrl = URLS.API;

  constructor(private carService: CarsService) {
  }

  ngOnInit(): void {
  }

  share(platform: string) {
    if (this.requireUpdate){
      this.notifyParent.emit();
    } else {
      switch (platform) {
        case 'print':
          window.open(this.shareUrl + 'cars/print?id=' + this.car.myCarId);
          break;
        case 'whatsapp':
          window.open(`https://wa.me?text=${encodeURIComponent(`מצורף תחשיב משוער ליבוא (${this.car.Manufacturer})`)} \n` + this.shareUrl + 'cars/print?id=' + this.car.myCarId);
          break;
        case 'savePdf':
          this.carService.exportCarToPdf(this.car).subscribe(res => {
            let blob = new Blob([res], {type: 'application/pdf'});
            saveAs(blob, `PO-${this.car.myCarId}.pdf`);
          });
          break;
        case 'email':
          window.open(`mailto:?subject=מצורף תחשיב משוער ליבוא (${this.car.Manufacturer + ' ' + this.car.Model})&body=${encodeURI(this.shareUrl + 'cars/print?id=' + this.car.myCarId)}`);
          break;
      }
    }
  }
}
